// Raw color tokens — the single source of truth for the whole design system.
// Lifted from the Parental Control Figma UI kit (semantic naming, not numbered ramps).
// Consumed by the UnoCSS preset (utility classes) AND the Naive UI theme map,
// so admin (Naive UI) and landing (custom UnoCSS) stay visually identical.

export const colors = {
  primary: {
    DEFAULT: "#0A56F9",
    light: "#84AAFC", // Light primary
    dark: "#2E4A84", // Dark blue (pressed/darker states)
  },
  secondary: {
    DEFAULT: "#C9DAFF",
    light: "#E8EFFF", // Light secondary
    stroke: "#B5CCFF", // Button stroke
  },
  danger: {
    DEFAULT: "#EB4542", // Red
    bright: "#FF2F2F", // Bright red
    light: "#FFA9A7", // Light red
    secondary: "#F8E5E5", // Red secondary
    stroke: "#FFC5C4", // Red stroke
  },
  success: {
    DEFAULT: "#178251", // Green
    light: "#00B123", // Light green
  },
  // Not present in the Figma kit — placeholder amber until the DS defines one.
  warning: {
    DEFAULT: "#F59E0B",
  },
  gray: {
    DEFAULT: "#505A6F",
    600: "#4B5563",
    // Not present in the Figma kit — placeholder tertiary/caption gray (landing).
    light: "#94A3B8",
    stroke: "#BFC5D1", // disabled input border (Figma "Input forms" 379:3800)
    border: "#D5D7E1", // unselected radio/checkbox border (Figma 322:2626 / 322:2615)
    track: "#A9C0D9", // switch off rail (Figma "Toggle" 263:1607)
  },
  neutral: {
    dark: "#1F1F1F",
    black: "#1A1A1A", // text/black
    white: "#FFFFFF",
  },
  // Alias of secondary.stroke — shorter utility for the very common border case.
  stroke: {
    DEFAULT: "#B5CCFF",
  },
  // Not present in the Figma kit — placeholder page-background tint (landing).
  background: {
    DEFAULT: "#FFFFFF", // alias of neutral.white
    soft: "#F8FAFF",
  },
} as const

export type Colors = typeof colors
